import { Controller } from "@hotwired/stimulus"

// Certificate rows speak "reads high/low by X kg"; storage is the
// canonical signed-additive correction (reads high => negative). A
// certificate point with NO error is still a point ("zero" stores an
// explicit 0); only the blank prompt means "nothing entered".
export default class extends Controller {
  static targets = ["direction", "magnitude", "signed"]

  connect() {
    const signed = parseFloat(this.signedTarget.value)
    if (!isNaN(signed)) {
      if (signed === 0) {
        this.directionTarget.value = "zero"
      } else {
        this.directionTarget.value = signed < 0 ? "reads_high" : "reads_low"
        this.magnitudeTarget.value = Math.abs(signed)
      }
    }
    this.sync()
  }

  sync() {
    const direction = this.directionTarget.value
    const magnitude = Math.abs(parseFloat(this.magnitudeTarget.value) || 0)
    this.magnitudeTarget.disabled = direction === "" || direction === "zero"
    if (direction === "zero") {
      this.signedTarget.value = "0"
    } else if (direction === "" || this.magnitudeTarget.value === "") {
      this.signedTarget.value = ""
    } else {
      this.signedTarget.value = direction === "reads_high" ? -magnitude : magnitude
    }
  }
}
